import { createTheme } from "@mui/material/styles";
import palette from "./palette";

const spacing = [
  0, 2, 4, 8, 12, 16, 20, 24, 32, 36, 48, 64, 80, 100, 120, 140, 160,
];

const breakpoints = {
  values: {
    xs: 390,
    sm: 540,
    md: 768,
    lg: 1200,
    xl: 1440,
  },
};

const theme = createTheme({
  spacing: spacing,
  breakpoints: breakpoints,
  palette: palette,
  components: {
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: palette.common.white,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: palette.background.paper,
          color: palette.common.white,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          color: palette.common.white,
          "&.Mui-disabled": {
            color: palette.common.white,
            WebkitTextFillColor: palette.common.white,
            opacity: 0.5,
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: "Inter",
          fontSize: 13,
          fontWeight: 600,
          color: palette.common.white,
          "&:hover": {
            backgroundColor: palette.grey[800],
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: "inter",
          color: palette.common.white,
        },
      },
    },
    MuiButton: {
      defaultProps: {
        size: "large",
      },
      styleOverrides: {
        root: {
          fontFamily: "Inter",
          fontWeight: 600,
          textTransform: "none",
          boxShadow: "none",
        },
        outlinedPrimary: {
          color: palette.primary.main,
          borderColor: palette.primary.main,
        },
        contained: {
          boxShadow: "none",
          borderWidth: 2,
          "&:hover": {
            boxShadow: "none",
          },
        },
        outlined: {
          boxShadow: "none",
          borderWidth: 2,
          "&:hover": {
            boxShadow: "none",
            borderWidth: 2,
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: palette.common.white,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderRadius: 6,
              backgroundColor: palette.grey[100],
              borderColor: palette.grey[700],
              color: palette.common.black,
            },
            "&:hover fieldset": {
              borderColor: palette.grey[700],
            },
            "&.Mui-focused fieldset": {
              borderColor: palette.grey[700],
              color: palette.common.black,
            },
          },
          "& .MuiInputBase-input": {
            color: palette.common.black,
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: "1px solid rgb(239 243 246 / 10%) !important",
        },
      },
    },
  },
});

export default theme;
